import React, { createContext, useReducer, useCallback } from "react";
import {
  VolumePriceContextType,
  VolumePriceState,
  ProviderProps,
} from "../types";

// Initial state
const initialState: VolumePriceState = {
  items: [],
};

// Create context
export const VolumePriceContext = createContext<VolumePriceContextType>({
  ...initialState,
  updateSupplierPriceVolume: () => {},
  cleanSupplierPriceVolume: () => {},
});

// VolumePrice reducer
const volumePriceReducer = (
  state: VolumePriceState,
  action: any
): VolumePriceState => {
  switch (action.type) {
    case "UPDATE_SUPPLIER_PRICE_VOLUME":
      const newState = [...state.items];
      const index = newState.findIndex((item) => {
        return item.id === action.item.id;
      });

      if (index === -1) {
        newState.push(action.item);
      } else {
        newState[index] = action.item;
      }

      return {
        ...state,
        items: newState,
      };
    case "CLEAN_SUPPLIER_PRICE_VOLUME":
      return {
        ...state,
        items: [],
      };
    default:
      return state;
  }
};

// Provider component
export const VolumePriceProvider: React.FC<ProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(volumePriceReducer, initialState);

  // Update supplier price volume action
  const updateSupplierPriceVolume = useCallback((item: any) => {
    dispatch({
      type: "UPDATE_SUPPLIER_PRICE_VOLUME",
      item,
    });
  }, []);

  // Clean supplier price volume action
  const cleanSupplierPriceVolume = useCallback(() => {
    dispatch({ type: "CLEAN_SUPPLIER_PRICE_VOLUME" });
  }, []);

  return (
    <VolumePriceContext.Provider
      value={{
        ...state,
        updateSupplierPriceVolume,
        cleanSupplierPriceVolume,
      }}
    >
      {children}
    </VolumePriceContext.Provider>
  );
};
